/**
 * CaptionsOverlay — bottom-of-screen live-caption chip.
 *
 * Displays a rolling window of the last N caption lines with a fade-in
 * effect. Renders `null` when no captions are enabled. Font/opacity/
 * position are theme-aware so the overlay never blows out on chapel-white
 * or stage-black themes.
 */
import React from 'react';

export default function CaptionsOverlay({ captions = [], variant = 'audience', lineLimit = 2, showCurrent = true, currentInterim = '' }) {
  const lines = [...captions.slice(-lineLimit)];
  if (showCurrent && currentInterim) {
    lines.push({ text: currentInterim, at: Date.now(), interim: true });
  }
  if (lines.length === 0) return null;

  const fontSize = variant === 'audience' ? '2.2rem'
    : variant === 'stage' ? '1.4rem'
    : '1.1rem';

  return (
    <div
      data-testid={`captions-overlay-${variant}`}
      className="pointer-events-none absolute inset-x-0 bottom-0 z-30 flex flex-col items-center gap-1 px-[6%] pb-6"
    >
      {lines.map((c, i) => (
        <div
          key={c.at + '_' + i}
          className="max-w-4xl rounded-md px-4 py-1.5"
          style={{
            background: 'rgba(0,0,0,0.55)',
            color: '#ffffff',
            fontSize,
            lineHeight: 1.3,
            opacity: c.interim ? 0.7 : (i === lines.length - 1 ? 1 : 0.75),
            textShadow: '0 1px 4px rgba(0,0,0,0.6)',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif',
            fontWeight: 500,
          }}
        >
          {c.text}
        </div>
      ))}
    </div>
  );
}
